// eslint-disable-next-line no-shadow
export enum CanvasImageSizeOptions {
	SQUARE = 'square',
	LANDSCAPE = 'landscape',
	PORTRAIT = 'portrait',
	WIDESCREEN = 'widescreen',
	MOBILE = 'mobile',
	INSTA = 'insta',
}
